import { useReducer } from 'react'

const CHANGE = 'change'

type CHANGE_PAYLOAD<T> = {
  name: keyof T
  value: T[keyof T]
}

type Action<T> = { type: typeof CHANGE; payload: CHANGE_PAYLOAD<T> }

const createReducer = <T>() => (state: T, action: Action<T>) => {
  switch (action.type) {
    case CHANGE: {
      const { name, value } = action.payload
      return {
        ...state,
        [name]: value,
      }
    }
    default:
      return state
  }
}

function useFormFields<T>(defaultState: T) {
  const reducer = createReducer<T>()
  const [state, dispatch] = useReducer(reducer, defaultState)

  function handleChange(payload: CHANGE_PAYLOAD<T>) {
    dispatch({
      type: CHANGE,
      payload,
    })
  }

  return {
    ...state,
    onChange: handleChange,
  }
}

export default useFormFields
